import { Avatar, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import { generosEnum } from '../../../../../widgets/fields/GenerosField';
import { getTipoSangre } from '../../../../../widgets/fields/TiposSangreField';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';

const InformacionEstudianteComponent = () => {
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const activo = estudiantesStore.activo;

  let seccionActivo;

  if (activo.matricula) {
    seccionActivo = activo.matricula?.secciones.find((el) => !el.aprobado);
  }
  return (
    <Stack direction="column" spacing={1}>
      <Paper elevation={4}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={12} align="center">
            <Avatar
              alt={activo.usuario.perfil.pnombre}
              sx={{ width: 150, height: 150, my: 2 }}
              src={getFilesArchivos(activo.usuario.perfil.avatar)}
            />
          </Grid>
          <Grid item xs={12} md={12} align="center">
            <Typography variant="h6">
              {activo.usuario.perfil.tipoDni}-{activo.usuario.perfil.dni}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} align="center">
            <Typography variant="h6">
              {activo.usuario.perfil.pnombre}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} align="center">
            <Typography variant="h6">
              {activo.usuario.perfil.papellido}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} align="center">
            <Divider textAlign="left" sx={{}}>
              Detalles
            </Divider>
          </Grid>
          <Grid item xs={12} md={12} sx={{ p: 2 }}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Correo: </strong>
                  {activo.usuario.correo}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Fecha de nacimiento: </strong>
                  {activo.usuario.perfil.fechaNacimiento}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Genero: </strong>
                  {generosEnum[activo.usuario.perfil.genero]}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Tipo sangre: </strong>
                  {getTipoSangre(activo.usuario.perfil.tipoSangre)}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Tiene internet: </strong>
                  {activo.usuario.perfil.internet ? 'SI' : 'NO'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Actividad Extcurricular: </strong>
                  {activo.usuario.perfil.actividadExtcur ? 'SI' : 'NO'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Identificacion escolar: </strong>
                  {activo.usuario.perfil.dniEscolar ? 'SI' : 'NO'}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Paper elevation={4} sx={{ p: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <Typography variant="h6" color="initial">
              Matrícula
            </Typography>
          </Grid>
          {activo.matricula ? (
            <>
              <Grid item xs={12} md={12}>
                <Typography variant="body">
                  <strong>Nro. de registro: </strong>
                  {activo.matricula.nroRegistro}
                </Typography>
              </Grid>

              <Grid item xs={12} md={12} align="center">
                <Divider textAlign="left">Seccion</Divider>
              </Grid>
              {seccionActivo ? (
                <>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Seccion: </strong>
                      {seccionActivo.seccion.nombre}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Turno: </strong>
                      {seccionActivo.seccion.turno}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography variant="body">
                      <strong>Nivel Academico: </strong>
                      {
                        seccionActivo.seccion.nivelAcademico.nivelAcademico
                          .nombre
                      }
                    </Typography>
                  </Grid>
                </>
              ) : (
                <Chip color="primary" label="No tiene una sección activa" />
              )}
            </>
          ) : (
            <Chip color="primary" label="No tiene matrícula asignada" />
          )}
        </Grid>
      </Paper>
    </Stack>
  );
};

export default InformacionEstudianteComponent;
